export class ProviderItemInputs {
    public ProviderInputId: string;
    public Value: string | any;
    constructor(ProviderInputId: string, Value: string | any) {
        this.ProviderInputId = ProviderInputId;
        this.Value = Value ? Value : '';
    }
}